import { Breadcrumb, Card, Col, Divider, Empty, Row } from 'antd';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import { orderManager } from 'src/services/order';

import { THIRD_PARTY_ORDER_STATUS } from './type';

export const thirdPartyOrdersQuery = gql`
  query getThirdPartyOrderQuery($ids: [ID]) {
    thirdPartyOrders(ids: $ids) {
      count
      orders {
        id
        originOrderId
        happenedAt
        orderId
        paymentAt
        platform
        raw
        status
        result
        userId
      }
    }
  }
`;

interface Props {
  match: any;
}

interface State {
  isShippingInformationModalVisible: boolean;
}

export class OrderDetail extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { isShippingInformationModalVisible: false };
  }

  onShippingInformationConfiremHandleOk() {
    this.setState({
      isShippingInformationModalVisible: false,
    });
  }

  render() {
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/order/list`}>订单列表</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>订单详情</Breadcrumb.Item>
        </Breadcrumb>
        <Query query={thirdPartyOrdersQuery} variables={{ ids: [this.props.match.params.id] }}>
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading...</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const { thirdPartyOrders = [] } = data || {};
            const { orders = [] } = thirdPartyOrders;

            const [order] = orders;

            const info = orderManager.getThirdPartyOrderInfo(order);

            const status = THIRD_PARTY_ORDER_STATUS.find(item => {
              return item.number === order.status;
            });

            return (
              <Card>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    订单信息
                  </Col>
                </Row>

                <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />

                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    订单编号:
                  </Col>
                  <Col span={4}>{order.orderId}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    原始单号:
                  </Col>
                  <Col span={4}>{order.originOrderId}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    订单状态:
                  </Col>
                  <Col span={4}>{status && status.name}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    状态信息:
                  </Col>
                  <Col span={4}>{order.result}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    订单类型:
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    退款状态:
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    下单时间:
                  </Col>
                  <Col span={5}>{moment(order.paymentAt).format('YYYY-MM-DD HH:mm:ss')}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    支付时间:
                  </Col>
                  <Col span={5}>{moment(order.happenedAt).format('YYYY-MM-DD HH:mm:ss')}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    数量:
                  </Col>
                  <Col span={3}>{info && info.qty}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    商品总金额:
                  </Col>
                  <Col span={3}>{info && info.totalPrice}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    课程名称:
                  </Col>
                  <Col span={12}>{info && info.tradeName}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    兑换码:
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    购买人:
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    支付方式:
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    支付单号:
                  </Col>
                  <Col span={5}>{info && info.payId}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    买家留言:
                  </Col>
                  <Col span={20}>{info && info.buyerComment}</Col>
                </Row>

                <Row gutter={24} style={{ marginTop: '30px' }}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    收件人信息
                  </Col>
                </Row>

                <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />

                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    收件人:
                  </Col>
                  <Col span={6}>{info && info.receiverName}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    收件人手机号:
                  </Col>
                  <Col span={6}>{info && info.receiverMobile}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    收件人证件号:
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    收件地址:
                  </Col>
                  <Col span={20}>{info && info.address}</Col>
                </Row>

                <Row gutter={24} style={{ marginTop: '30px' }}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    发件信息
                  </Col>

                  {
                    // TODO (sunshabin) 后续需加上回填物流信息
                    /* <Col span={19} style={{ textAlign: 'right', color: 'blue' }}>
                  <span
                    onClick={() => {
                      this.setState({
                        isShippingInformationModalVisible: true,
                      });
                    }}
                  >
                    修改发货信息
                  </span>
                </Col> */
                  }
                </Row>

                <Divider style={{ marginTop: '8px', marginBottom: '8px' }} />

                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    商品名称:
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    商品编码:
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    数量:
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    物流单号:
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    物流公司:
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={4} style={{ textAlign: 'right' }}>
                    发货时间:
                  </Col>
                </Row>
                {
                  // TODO (sunshabin) 后续需加上回填物流信息
                  /* <Modal
                title="修改发货信息"
                visible={this.state.isShippingInformationModalVisible}
                onOk={() => {
                  this.onShippingInformationConfiremHandleOk();
                }}
                onCancel={() => {
                  this.setState({
                    isShippingInformationModalVisible: false,
                  });
                }}
              >
                <Row gutter={24}>
                  <Col span={5} style={{ textAlign: 'right', marginTop: '6px' }}>
                    *物流单号:
                  </Col>
                  <Col span={12}>
                    <Input placeholder="" />
                  </Col>
                </Row>
                <Row gutter={24} style={{ marginTop: '10px' }}>
                  <Col span={5} style={{ textAlign: 'right', marginTop: '6px' }}>
                    *物流公司:
                  </Col>
                  <Col span={12}>
                    <Select defaultValue="lucy" style={{ width: 120 }}>
                      <Select.Option value="jack">Jack</Select.Option>
                      <Select.Option value="lucy">Lucy</Select.Option>
                      <Select.Option value="Yiminghe">yiminghe</Select.Option>
                    </Select>
                  </Col>
                </Row>
              </Modal> */
                }
              </Card>
            );
          }}
        </Query>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/order/OrderDetail.tsx